// extracted by mini-css-extract-plugin
export var active = "navDropdown-module--active--c4344";
export var navDropdown = "navDropdown-module--navDropdown--61e05";
export var trigger = "navDropdown-module--trigger--addbb";